/**
 * components/UploadGlobalConf/FileTreeRenderer.js
 * Gestion du rendu de l'arbre des fichiers
 */

export class FileTreeRenderer {
  constructor(parent) {
    this.parent = parent;
  }

  /**
   * Rendre l'arbre des fichiers
   */
  renderFileTree() {
    if (!this.parent.element) return;

    const treeContainer = this.parent.element.querySelector(".file-tree-container");
    if (!treeContainer) return;

    if (this.parent.uploadedFiles.length === 0) {
      treeContainer.innerHTML = '<div class="tree-empty">Aucun fichier chargé</div>';
      return;
    }

    const treeHTML = this.parent.uploadedFiles
      .map((item) => {
        const assigned = this.parent.assignedItems.get(item.name);
        return this.renderTreeItem(item, assigned);
      })
      .join("");

    treeContainer.innerHTML = `<div class="file-tree">${treeHTML}</div>`;
  }

  /**
   * Rendre un élément de l'arbre
   */
  renderTreeItem(item, assigned) {
    const icon = item.type === "file" ? "📄" : "📁";
    const statusClass = assigned ? `tree-item-${assigned.status}` : "tree-item-unassigned";

    let itemHTML = `
      <div class="tree-item ${statusClass}" data-item-name="${item.name}">
        <div class="tree-item-header">
          <span class="tree-item-icon">${icon}</span>
          <span class="tree-item-name">${item.name}</span>
          ${
            !assigned
              ? `
            <button class="tree-item-assign-btn" data-item-name="${item.name}" title="Assigner à une catégorie">
              🔗
            </button>
            <button class="tree-item-exclude-btn" data-item-name="${item.name}" title="Exclure de la liste">
              🗑️
            </button>
          `
              : `
            <button class="tree-item-unassign-btn" data-item-name="${item.name}" title="Libérer l'assignation">
              🔓
            </button>
          `
          }
        </div>
    `;

    // Ajouter les sous-nœuds si nécessaire
    //if (assigned && assigned.subNodes) {
    if (assigned && assigned.subNodes && (assigned.subNodes.sheet || assigned.subNodes.column)) {
      itemHTML += '<div class="tree-subnodes">';

      if (assigned.subNodes.sheet) {
        itemHTML += this.renderSubNode(
          item.name,
          "sheet",
          "Feuille:",
          assigned.subNodes.sheet,
          assigned.availableSheets
        );
      }

      if (assigned.subNodes.column) {
        itemHTML += this.renderSubNode(
          item.name,
          "column",
          "Colonne:",
          assigned.subNodes.column,
          assigned.subNodes.column.options
        );
      }

      itemHTML += "</div>";
    }

    itemHTML += "</div>";

    return itemHTML;
  }

  /**
   * Rendre un sous-nœud
   */
  renderSubNode(itemName, nodeType, label, nodeData, options) {
    const statusIcon =
      {
        pending: "⏳",
        completed: "✅",
        disabled: "🚫",
        error: "❌",
      }[nodeData.status] || "⏳";

    let content = "";
    if (nodeData.status === "pending" && options && options.length > 0) {
      const optionsList = options
        .map((opt) => {
          const value = typeof opt === "object" ? opt.name : opt;
          const display = typeof opt === "object" ? opt.name : opt;
          return `<option value="${value}">${display}</option>`;
        })
        .join("");

      content = `
        <select class="subnode-select" data-item-name="${itemName}" data-node-type="${nodeType}">
          <option value="">-- Sélectionner --</option>
          ${optionsList}
        </select>
      `;
    } else if (nodeData.status === "completed") {
      const selected = typeof nodeData.selected === "object" ? nodeData.selected.name : nodeData.selected;
      content = `<span class="subnode-value">${selected}</span>`;
    } else if (nodeData.status === "error") {
      content = `<span class="subnode-error">${nodeData.error}</span>`;
    } else {
      content = '<span class="subnode-disabled">En attente...</span>';
    }

    return `
      <div class="tree-subnode tree-subnode-${nodeData.status}">
        <span class="subnode-icon">${statusIcon}</span>
        <span class="subnode-label">${label}</span>
        ${content}
      </div>
    `;
  }

  /**
   * Rendre le statut d'un élément
   */
  renderItemStatus(assigned) {
    if (!assigned) return "";

    const statusIcons = {
      processing: "⏳ Traitement...",
      success: "✅ Traité",
      error: "❌ Erreur",
      pending_subnodes: "⏳ Configuration...",
    };

    const statusText = statusIcons[assigned.status] || assigned.status;
    const statusClass = `tree-item-status status-${assigned.status}`;

    return `<span class="${statusClass}">${statusText}</span>`;
  }
}
